import mapSpot from './map-spot';
import hdd from './hdd';

export default {
	...mapSpot,
	...hdd
};
